import logo from '../../../../assets/images/zeuspix-logo-2.png'; // Ajuste o caminho conforme necessário
import DrawerMenuOptions from '../DrawerMenuOptions';

function Header() {
    return (
        <div style={{
            position: 'relative', // Para posicionamento absoluto dos filhos
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center', // Centraliza os itens no eixo horizontal
            width: '100%',
            backgroundColor: '#2E2E2E',
            padding: '0', // Removido padding para evitar espaçamento extra
            height: '80px', // Define altura fixa
            boxSizing: 'border-box', // Evita problemas com o cálculo de altura
            overflow: 'hidden', // Garante que não haverá barras de rolagem
        }}>
            {/* DrawerMenuOptions alinhado à esquerda */}
            <div style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)' }}>
                <DrawerMenuOptions />
            </div>

            {/* Logo centralizada */}
            <div style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                <img src={logo} alt="Logo" style={{ height: '70px' }} />
            </div>
        </div>
    );
}

export default Header;
